var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryDropDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 12,
    viewBox: "0 0 24 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3389 10.3797L1.11963 2.51618C0.573307 0.943536 2.03018 1.11195 2.8269 1.39274L12.0462 8.69461L21.2654 1.11198C22.9044 0.662631 23.0865 1.67366 22.9727 2.23534L13.412 10.3797C12.3193 11.5031 10.908 10.8478 10.3389 10.3797Z",
    fill: "#1F75A8",
    stroke: "#1F75A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryDropDown);
export default __webpack_public_path__ + "static/media/PrimaryDropDown.d68c367dbf5d52f3e1c1ed6d96f7dea9.svg";
export { ForwardRef as ReactComponent };